"use client";

import { SignUpButton } from "@clerk/nextjs";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { MARKETING_LANDING_SECTION_IDS } from "@/lib/marketing/landing-anchors";
import { scrollToElementById } from "@/lib/utils";

export const MarketingFinalCtaSection = () => {
  const handleComparePlansClick = () => {
    scrollToElementById(MARKETING_LANDING_SECTION_IDS.pricing);
  };

  return (
    <section
      aria-labelledby="final-cta-heading"
      className="mt-14 scroll-mt-24"
      id={MARKETING_LANDING_SECTION_IDS.finalCta}
    >
      <Card className="border-border/60 bg-card/40 p-6 shadow-sm">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <h2 className="font-medium text-sm" id="final-cta-heading">
              Ready to retire the spreadsheet?
            </h2>
            <p className="text-muted-foreground text-sm">
              Spin up an organization, import your strings, and ship your first localized release
              this week.
            </p>
          </div>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <SignUpButton fallbackRedirectUrl="/app">
              <Button className="h-9">Create your workspace</Button>
            </SignUpButton>
            <Button
              className="h-9"
              onClick={handleComparePlansClick}
              type="button"
              variant="outline"
            >
              Compare plans
            </Button>
            <Button asChild className="h-9" variant="ghost">
              <Link href="/status">System status</Link>
            </Button>
          </div>
        </div>
      </Card>
    </section>
  );
};
